import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-canvas-bbox-search-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './canvas-bbox-search-banner.component.html',
  styleUrl: './canvas-bbox-search-banner.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CanvasBboxSearchBannerComponent {
  @Input() visible = false;
  @Input() resourceCount = 0;
  @Input() selectedCount = 0;

  @Output() listAllResults = new EventEmitter<void>();
  @Output() clearBbox = new EventEmitter<void>();
  @Output() backToDatasets = new EventEmitter<void>();
}
